function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#currencyExchange_svg__clip0_13_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.81 11.182c-1.62-.537-2.4-.873-2.4-1.727 0-.928 1.008-1.264 1.645-1.264 1.19 0 1.627.9 1.727 1.218l1.436-.609c-.136-.41-.745-1.745-2.309-2.036V5.636h-1.818v1.146c-2.255.509-2.264 2.6-2.264 2.69 0 2.064 2.046 2.646 3.046 3.01 1.436.509 2.072.973 2.072 1.845 0 1.027-.954 1.464-1.8 1.464-1.654 0-2.127-1.7-2.181-1.9l-1.51.609c.573 1.99 2.073 2.527 2.637 2.69v1.174h1.818v-1.128c.364-.082 2.636-.536 2.636-2.927 0-1.263-.554-2.373-2.736-3.127zm-8.992 9H2v-5.455h5.455v1.819H5.2a8.166 8.166 0 006.8 3.636A8.182 8.182 0 0020.182 12H22c0 5.527-4.473 10-10 10a10 10 0 01-8.182-4.245v2.427zM2 12C2 6.473 6.473 2 12 2a10 10 0 018.182 4.245V3.818H22v5.455h-5.454V7.455H18.8A8.166 8.166 0 0012 3.818 8.182 8.182 0 003.818 12H2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "currencyExchange_svg__clip0_13_5754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};
const SvgCurrencyExchange = styled(BaseComponent).withConfig({
  displayName: "CurrencyExchange__SvgCurrencyExchange",
  componentId: "sc-x0b70z-0"
})(["outline:none;"]);
SvgCurrencyExchange.isIcon = true;
SvgCurrencyExchange.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgCurrencyExchange;